import type { ApiObject } from "@rudderstack/analytics-js";
import { useEffect } from "react";
import { createDependencyString } from "../helpers/createDependencyString";
import { groupRudderStackUser, identifyRudderStackUser } from "./rudderstack";

export const useIdentifyRudderstackUser = (
  isSessionStarted: boolean,
  userId: string | undefined,
  identifyUserTraits?: ApiObject | undefined
) => {
  const dependencyString = createDependencyString(identifyUserTraits ?? {});

  useEffect(() => {
    if (isSessionStarted && userId) {
      identifyRudderStackUser(userId, identifyUserTraits);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSessionStarted, userId, dependencyString]);
};

export const useGroupRudderstackUser = (
  isSessionStarted: boolean,
  accountId: string | undefined,
  groupData?: ApiObject | undefined
) => {
  const dependencyString = createDependencyString(groupData ?? {});
  useEffect(() => {
    if (isSessionStarted && accountId) {
      groupRudderStackUser(accountId, {
        accountId,
        ...groupData,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSessionStarted, accountId, dependencyString]);
};
